module.exports = __webpack_public_path__ + "img/many_lorry.b837ae3f.jpg";